import loadable from '@loadable/component';

const DefaultLoader = loadable(() => import(/* webpackChunkName: "default-loader" */ './DefaultLoader'));
const SingleColumnLayoutLoader = loadable(() => import(/* webpackChunkName: "single-column-layout" */ './SingleColumnLayoutLoader'));

export {
    DefaultLoader,
    SingleColumnLayoutLoader,
};
